export default __webpack_public_path__ + "static/media/Error404.b2804769.svg";